import { styled, Box as MuiBox } from "@mui/material";

export const Container = styled(MuiBox)(
  ({ theme: { breakpoints } }) => `
    &.MuiBox-root {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
      margin: 40px 0;

      ${breakpoints.up("sm")} {
        margin: 47px 16px 40px;
      }

      ${breakpoints.up("md")} {
        grid-template-columns: repeat(2, 1fr);
        margin: 47px 20px 40px;
      }

      ${breakpoints.up("lg")} {
        grid-template-columns: repeat(4, 1fr);
        margin: 47px 32px 40px;
        gap: 32px;
      }
    }
  `
);
